module.exports = __webpack_public_path__ + "img/hm_block03_04_en.dd338376.png";